import {Component, EventEmitter, Output} from '@angular/core';
import {StepsSyncDialogComponent} from "../../steps/steps-sync-dialog/steps-sync-dialog.component";
import {SplittypayError} from "../../core/error.service";

@Component({
  selector: 'app-unpaid-header',
  templateUrl: './unpaid-header.component.html',
  styleUrls: ['./unpaid-header.component.scss']
})
export class UnpaidHeaderComponent {

  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();

}
